import { useEffect, useState } from 'react';

/** Whether the phone says it is online, kept up to date as that changes. */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine));
  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
    };
  }, []);
  return online;
}

/**
 * Opened with no signal, the app shows the chat and photos it already has on
 * the phone -- the database keeps its own copy, the service worker the app and
 * the pictures -- and says so, so a quiet thread reads as no signal rather than
 * as nobody having said anything. Anything sent goes once the signal is back.
 */
export function OfflineNote() {
  const online = useOnline();
  if (online) return null;
  return (
    <div className="offline-note" role="status">
      Offline · showing what was saved. Anything you send goes when you&rsquo;re back.
    </div>
  );
}
